import { createFileRoute } from "@tanstack/react-router";
import { PublicTemplatesPage } from "@/features/templates/components/PublicTemplatesPage";

export const Route = createFileRoute("/_app/templates/public")({
    component: PublicTemplatesPage,
});
